<script>
    import { Col, Container, Row, Nav } from 'sveltestrap'
    import { tabTool } from '@fno/service/api/tasks.js'
    import keyBy from '@fno/lib/key-by.js'
    import stepIdToRoute from './step-id-to-route.js'
    import Link from './HelloMenuNavItem.svelte'
    import Footer from './HelloMenuFooter.svelte'

    import taskSchema from 'fanx-schema/resource/taskTabTool.js'
    const stepItems = taskSchema.properties.steps.fragments.map((step) => ({
        path: stepIdToRoute[step.id],
        title: step.label,
        id: step.id
    }))

    export let asr
    export let schoolId

    let staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'
    let windowLocationPath = window.location.pathname
    let windowWidth = 1025
    $: stepById = keyBy(($tabTool && $tabTool.attributes.steps) || [], 'id')

    const items = [
        ...stepItems,
        {
            path: 'hello.task.allDone',
            title: 'Finish'
        }
    ]
</script>

<style>
    main :global(div.fno-menu-header) {
        max-height: 150px;
    }

    main :global(.nav-pills .nav-link.active, .nav-pills .show > .nav-link, .nav > li > a:hover, .nav > li > a:focus) {
        background-color: #ccf4ff;
        color: #077175;
    }
</style>

<svelte:window bind:innerWidth={windowWidth} />

<div>
    <Container>
        <Row>
            <Col>
                <div class="d-flex flex-column">
                    <main class="flex-shrink-0">
                        <div class="fno-menu-header text-center mt-4 d-flex flex-column justify-content-around">
                            <a href={windowLocationPath}>
                                <img
                                    alt="Logo of From Now On."
                                    src="{staticAssetPrefix}img/fromnowon-logo-03.png"
                                    class="img-fluid"
                                />
                            </a>
                            <p class="text-uppercase mt-3 mb-0 font-weight-bold">T.A.B.</p>
                            <p style="font-weight: 200;"><em>Turbo App Builder</em></p>
                        </div>

                        <hr class="fno-menu-hr" />

                        <p>QUICK LINKS</p>

                        <Nav vertical pills>
                            {#each items as { path, title, id }}
                                <Link
                                    showIcon={true}
                                    status={stepById && stepById[id] && stepById[id].status}
                                    {asr}
                                    {path}
                                    {title}
                                    {schoolId}
                                />
                            {/each}
                        </Nav>
                    </main>
                    <Footer {asr} />
                </div>
            </Col>
        </Row>
    </Container>
</div>
